import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function ChevronLeftIcon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg height="1em" viewBox="0 0 24 24" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.2996 8.73966C14.5814 9.0432 14.5639 9.51775 14.2603 9.7996L11.3522 12.5L14.2603 15.2004C14.5639 15.4823 14.5814 15.9568 14.2996 16.2603C14.0177 16.5639 13.5432 16.5815 13.2397 16.2996L9.73966 13.0496C9.58683 12.9077 9.5 12.7086 9.5 12.5C9.5 12.2915 9.58683 12.0923 9.73966 11.9504L13.2397 8.70041C13.5432 8.41856 14.0177 8.43613 14.2996 8.73966Z"
        fill="currentColor"
      />
    </svg>
  );
};
